import { render } from "./ComprasCreate.vue?vue&type=template&id=20fc5b4b&scoped=true"
import script from "./ComprasCreate.vue?vue&type=script&lang=js"
export * from "./ComprasCreate.vue?vue&type=script&lang=js"

import "./ComprasCreate.vue?vue&type=style&index=0&id=20fc5b4b&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fc5b4b"]])

export default __exports__